module.exports = __webpack_public_path__ + "img/rooted_thumbnail.a4c34260.jpg";